import { render, staticRenderFns } from "./ChecklistTab.vue?vue&type=template&id=5367af8b"
import script from "./ChecklistTab.vue?vue&type=script&lang=js"
export * from "./ChecklistTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports